import { Feature } from '../models/feature.model';
import { Permission } from '../models/permission.model';
import { Injectable } from '@angular/core';

/**
 * Service responsible for managing features.
 *
 * @export
 * @class FeatureService
 */
@Injectable()
export class FeatureService {
  /**
   * List of features available for assignment
   *
   * @memberof Feature[]
   */
  public availableFeatures: Feature[] = [
    new Feature({
      Type: 'access-permissions-feature',
    }),
    new Feature({
      Type: 'access-reports-feature',
    }),
    new Feature({
      Type: 'access-station-maintenance-feature',
    }),
    new Feature({
      Type: 'access-load-management-feature',
    }),
    new Feature({
      Type: 'access-rocketmaster-feature',
    }),
    new Feature({
      Type: 'access-autoexport-feature',
    }),
    new Feature({
      Type: 'access-hubject-feature',
    }),
    new Feature({
      Type: 'advanced-user-management-feature',
    }),
    new Feature({
      Type: 'access-auto-payout-feature',
    }),
    new Feature({
      Type: 'access-price-plans-feature',
    }),
  ];

  /**
   * Returns whether the permission is enabling a user feature.
   */
  public isPermissionFeatureRelated(permission: Permission): boolean {
    return this.availableFeatures.some((f) => f.Type === permission.type);
  }
}
